import { AnyAction } from '@reduxjs/toolkit'
import { Epic } from 'redux-observable'
import { of, from } from 'rxjs'
import { switchMap, map, catchError, withLatestFrom, filter } from 'rxjs/operators'

import { validateIban, validateIbanSuccess, validateIbanError } from './payments.reducer'

import IbanService from '../iban/services/iban.service'
import { GenericError } from '../model/iban.model'

import { RootState } from '~/core/store/root.reducer'

const validateIbanEpic: Epic<AnyAction, AnyAction, RootState, { ibanService: IbanService }> = (
  action$,
  state$,
  { ibanService },
) =>
  action$.pipe(
    filter(validateIban.match),
    withLatestFrom(state$),
    switchMap(([action]) =>
      from(ibanService.validateIban(action.payload)).pipe(
        map((res) => validateIbanSuccess(res.isValid)),
        catchError((error: GenericError) => of(validateIbanError(error))),
      ),
    ),
  )

const paymentsEpics = {
  validateIbanEpic,
}

export default paymentsEpics
